import React, {Component} from 'react';
import {NavLink, Link} from 'react-router-dom';
import {connect} from "react-redux";
import ReactTooltip from 'react-tooltip';

import {getUser} from "../../utils/TokenManager";
import logo from "../../public/assets/images/symphony_logo_large_1.png";
import logoMini from "../../public/assets/images/small_logo_new_3.png";
import SupportModal from "../staffDashboard/SupportModal";


class SideNav extends Component {

    state = {
        openSupportModal: false,
        isOpenAdmin: false,
        isOpenReport: false,
        isOpenResources: false
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.fullSideBar && !this.props.fullSideBar) {
            this.closeAllMenu();
        }
    }

    closeAllMenu = () => {
        this.setState({
            isOpenAdmin: false,
            isOpenResources: false,
            isOpenReport: false
        });
        return false;
    }

    toggleAdminMenu = () => {
        this.setState(prevState => ({
            isOpenAdmin: !prevState.isOpenAdmin,
            isOpenResources: false,
            isOpenReport: false
        }));
        this.props.openSideBar();
        return false;
    }

    toggleReportMenu = () => {
        this.setState(prevState => ({
            isOpenReport: !prevState.isOpenReport,
            isOpenResources: false,
            isOpenAdmin: false
        }));
        this.props.openSideBar();
        return false;
    }

    toggleResourcesMenu = () => {
        this.setState(prevState => ({
            isOpenResources: !prevState.isOpenResources,
            isOpenReport: false,
            isOpenAdmin: false
        }));
        this.props.openSideBar();
        return false;
    }

    openSupport = () => {
        this.setState({openSupportModal: true});
    }

    toggleSupportModal = () => {
        this.setState((prevState) => ({openSupportModal: !prevState.openSupportModal}));
    };

    render = () => {
        const {fullSideBar, selectedMenu, selectedSubMenu} = this.props;
        const {isOpenReport, isOpenAdmin, isOpenResources} = this.state;
        const isAgencyMonitorVisble = getUser().agency_monitor;

        return (
            <aside className={`sidebar ${fullSideBar ? "full" : "mini"}`}>
                <div className={`navbar-header ${fullSideBar ? "p-1 mt-2" : "p-2 mt-2"}`}>
                    <Link to="/home" title="Symphony Home">
                        {fullSideBar ? 
                            <span className="logo-text">
                                <img src={logo} alt="homepage"/>
                            </span>
                            :
                            <span className="logo-mini-text">
                                <img src={logoMini} alt="homepage"/>
                            </span>
                        }
                    </Link>
                </div>
                <div className="scroll-sidebar">
                    <nav className="sidebar-nav">
                        <ul className="ul-flex">
                            <li className="sidebar-item link-heading cursor-pointer" 
                                data-tip data-for="home-info" 
                                data-place="right" data-delay-show="500"
                                onClick={this.closeAllMenu}
                            >
                                <NavLink className={`sidebar-link ${
                                        selectedMenu === 'home' && 'active'
                                    }`} to="/home"
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-home pr-1"></i>
                                            Dashboard
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-home mx-auto font-24 pt-3 pb-2"></i>
                                    }
                                </NavLink>
                                <ReactTooltip className="react-tooltip-class" id="home-info">
                                    Home
                                </ReactTooltip>
                            </li>
                            <li className="sidebar-item link-heading cursor-pointer">
                                <a  onClick={this.toggleAdminMenu}
                                    className={`sidebar-link ${
                                        selectedMenu === 'admin' && 'active'
                                    }`}
                                    data-tip data-for="admin-info" 
                                    data-place="right" data-delay-show="500"
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-lock pr-1"></i>
                                            Admin
                                            <i className={`fa caret-icon ${
                                                isOpenAdmin ? 
                                                    'fa-caret-down' 
                                                    : 'fa-caret-right'}`
                                            }></i>
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-lock mx-auto font-24 pt-3 pb-2"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="admin-info">
                                    Admin
                                </ReactTooltip>
                                {isOpenAdmin && 
                                    <ul className="sub-menu">
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'agencyProfile' && 'active'
                                                }`} 
                                                to="/agency-profile"
                                            >Agency Profile</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'manageUser' && 'active'
                                                }`} 
                                                to="/user-profile"
                                            >Manage User</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'assignPermission' && 'active'
                                                }`} 
                                                to="/assign-permission"
                                            >Assign Permissions</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'agencyMonitor' && 'active'
                                                }`} 
                                                to="/agency-monitor"
                                            >Agency Monitor</NavLink>
                                        </li>
                                    </ul>
                                }
                            </li>
                            <li className="sidebar-item link-heading cursor-pointer">
                                <a onClick={this.toggleReportMenu} 
                                    data-tip data-for="report-info" 
                                    data-place="right" data-delay-show="500"
                                    className={`sidebar-link ${
                                        selectedMenu === 'reports' && 'active'
                                    }`}
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-file pr-1"></i>
                                            Reports
                                            <i className={`fa caret-icon ${
                                                isOpenReport ? 
                                                    'fa-caret-down' 
                                                    : 'fa-caret-right'}`
                                            }></i>
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-file mx-auto font-20 pt-3 pb-2"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="report-info">
                                    Reports
                                </ReactTooltip>
                                {isOpenReport && 
                                    <ul className="sub-menu">
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'commission-report' && 'active'
                                                }`} 
                                                to="/reports/#commission-report"
                                            >Commission/Revenue <br/>Sharing Report</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'compensation-agreement' && 'active'
                                                }`} 
                                                to="/reports/#compensation-agreement"
                                            >Compensation <br/>Agreement</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'staff-data' && 'active'
                                                }`} 
                                                to="/reports/#staff-data"
                                            >Export Staff Data</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'activity-report' && 'active'
                                                }`} 
                                                to="/reports/#activity-report"
                                            >Activity Report</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'kpi-explanations' && 'active'
                                                }`}  
                                                to="/reports/#kpi-explanations"
                                            >KPI Explanations</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'performance-evaluation' && 'active'
                                                }`} 
                                                to="/reports/#performance-evaluation"
                                            >Performance <br/>Evaluation Report</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'staff-timesheet' && 'active'
                                                }`} 
                                                to="/reports/#staff-timesheet"
                                            >Staff Timesheet</NavLink>
                                        </li>
                                    </ul>
                                }
                            </li>
                            <li className="sidebar-item link-heading cursor-pointer">
                                <a onClick={this.toggleNav} 
                                    className={`sidebar-link ${
                                        selectedMenu === 'resources' && 'active'
                                    }`}
                                    onClick={this.toggleResourcesMenu}
                                    data-tip data-for="resources-info" 
                                    data-place="right" data-delay-show="500"
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-briefcase pr-1"></i>
                                            Resources
                                            <i className={`fa caret-icon ${
                                                isOpenResources ? 
                                                    'fa-caret-down' 
                                                    : 'fa-caret-right'}`
                                            }></i>
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-briefcase mx-auto font-20 pt-3 pb-2"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="resources-info">
                                    Resources
                                </ReactTooltip>
                                {isOpenResources && 
                                    <ul className="sub-menu">
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'pl' && 'active'
                                                }`} 
                                                to="/pl-worksheet"
                                            >P&L Worksheet</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'peerEval' && 'active'
                                                }`} 
                                                to="/peer-evaluation"
                                            >Peer Evaluation</NavLink>
                                        </li>
                                        <li className="sidebar-item">
                                            <NavLink 
                                                className={`sidebar-link ${
                                                    selectedSubMenu === 'kpiPlanning' && 'active'
                                                }`} 
                                                to="/kpi-planning"
                                            >KPI Planning</NavLink>
                                        </li>
                                    </ul>
                                }
                            </li>
                            <li className="sidebar-item link-heading cursor-pointer" 
                                onClick={this.closeAllMenu}
                                data-tip data-for="pto-info" 
                                data-place="right" data-delay-show="500"
                            >
                                <NavLink className={`sidebar-link ${
                                        selectedMenu === 'pto' && 'active'
                                    }`} to="/pto"
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-calendar pr-1"></i>
                                            PTO/Sick Leave
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-calendar mx-auto font-20 pt-3 pb-2"></i>
                                    }
                                </NavLink>
                                <ReactTooltip className="react-tooltip-class" id="pto-info">
                                    Paid Time Off Settings
                                </ReactTooltip>
                            </li>
                            <li className="sidebar-item link-heading cursor-pointer" 
                                onClick={this.closeAllMenu}
                                data-tip data-for="producerComp-info" 
                                data-place="right" data-delay-show="500"
                            >
                                <NavLink className={`sidebar-link ${
                                        selectedMenu === 'producerComp' && 'active'
                                    }`} to="/producer-compensation"
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-money pr-1"></i>
                                            Producer Compensation
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-money mx-auto font-20 pt-3 pb-2"></i>
                                    }
                                </NavLink>
                                <ReactTooltip className="react-tooltip-class" 
                                    id="producerComp-info"
                                >
                                    Producer Compensation
                                </ReactTooltip>
                            </li>
                            <li className="sidebar-item link-heading cursor-pointer" 
                                onClick={this.closeAllMenu}
                                data-tip data-for="kb-info" 
                                data-place="right" data-delay-show="500"
                            >
                                <NavLink className="sidebar-link" to="/knowledgebase">
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-question-circle pr-1"></i>
                                            Knowledge Base
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-question-circle mx-auto font-22 pt-3 pb-2"></i>
                                    }
                                </NavLink>
                                <ReactTooltip className="react-tooltip-class" id="kb-info">
                                    Knowledge Base
                                </ReactTooltip>
                            </li>
                            {isAgencyMonitorVisble &&
                            <li className="sidebar-item link-heading cursor-pointer"
                                data-tip data-for="agency-monitor" 
                                data-place="right" data-delay-show="500"
                                onClick={this.closeAllMenu}
                            >
                                
                                <a onClick={this.openAgencyMonitor} href="/agency-monitor-staff" target="_blank" className="sidebar-link">
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-television"></i>
                                            Agency Monitor
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-television mx-auto font-20 py-3"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="agency-monitor">
                                    Agency Monitor
                                </ReactTooltip>
                            </li>
                            }
                            <li className="sidebar-item link-heading cursor-pointer"
                                data-tip data-for="support-info" 
                                data-place="right" data-delay-show="500"
                                onClick={this.closeAllMenu}
                            >
                                <a onClick={this.openSupport} className="sidebar-link">
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-life-ring pr-1"></i>
                                            Support
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-life-ring mx-auto font-20 pt-3 pb-2"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="support-info">
                                    Support
                                </ReactTooltip>
                            </li>
                        </ul>
                    </nav>
                </div>
                {this.state.openSupportModal &&
                    <SupportModal {...this.props} modal={this.state.openSupportModal} 
                        toggleModal={this.toggleSupportModal} />
                }
            </aside>
        );
    };
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer
    };
}

export default connect(mapStateToProps, null)(SideNav);



// WEBPACK FOOTER //
// ./src/components/nav/SideNav.js